import { InputAdornment, TextField } from '@mui/material';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const StandardAmountCharged = () => {
  const { control, getValues } = useFormContext();
  const { t } = useTranslation();
  const standardAmountCharged = 'standardAmountCharged';

  return (
    <Controller
      control={control}
      name={standardAmountCharged}
      render={({ field: { onChange, value, ...rest } }) => (
        <TextField
          variant="filled"
          fullWidth
          id="standardAmountCharged"
          color="primary"
          autoComplete="off"
          label={t('placement.placementMods.standardAmountCharged')}
          InputProps={{
            readOnly: true,
            style: {
              pointerEvents: 'none',
            },
            startAdornment: <>{value && <InputAdornment position="start">$</InputAdornment>}</>,
          }}
          value={getValues(standardAmountCharged) ?? ''}
        />
      )}
    />
  );
};
